import React from 'react'
import Members from './Members'

function team({data}) {
  return (
    <>
    <Members data={data}/>
    </>
  )
}

export default team